export default __webpack_public_path__ + "static/mohamed-74cf44788d450819da64367a3400ae2e.jpg";